import { mode } from '@chakra-ui/theme-tools';

const activeStyles = {
  top: 0,
  left: 0,
  zIndex: 2,
  position: 'absolute',
  pointerEvents: 'none',
  mx: 3.5,
  px: 1,
  my: 3.5,
  transformOrigin: 'left top',
  color: '#9FABCB',
  fontSize: '16px',
  fontWeight: '500',
  borderRadius: '6px'
};

const activeLabelStyles = {
  transform: 'scale(0.88) translateY(-28px)'
};

export const formStyles = {
  components: {
    Form: {
      variants: {
        floating: {
          container: {
            input: {
              p: '20px 16px !important'
            },
            _focusWithin: {
              label: {
                ...activeLabelStyles
              }
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
              ...activeLabelStyles
            },
            label: (props) => ({
              ...activeStyles,
              backgroundColor: mode('white', 'white')(props),
            })
          }
        },
        calm: {
          container: {
            input: {
              border: '1px solid transparent !important',
              p: '20px 16px !important',
              pointerEvents: 'none !important'
            },
            _focusWithin: {
              label: {
                ...activeLabelStyles
              }
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
              ...activeLabelStyles
            },
            label: (props) => ({
              ...activeStyles,
              backgroundColor: mode('white', 'white')(props),
            })
          }
        },
        calmPhone: {
          container: {
            input: {
              bg: 'transparent !important',
              border: '1px solid transparent !important',
              p: '20px 16px 20px 69px !important',
              pointerEvents: 'none !important'
            },
            _focusWithin: {
              label: {
                ...activeLabelStyles
              }
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
              ...activeLabelStyles
            },
            label: (props) => ({
              ...activeStyles,
              backgroundColor: mode('#0A1027', '#262D47')(props),
            })
          }
        },
        floatingForgot: {
          container: {
            input: {
              bg: '#0E1633 !important',
              border: '0px solid #262D47 !important',
              p: '20px 16px !important'
            },
            _focusWithin: {
              label: {
                ...activeLabelStyles
              }
            },
            'input:not(:placeholder-shown) + label, .chakra-select__wrapper + label, textarea:not(:placeholder-shown) ~ label': {
              ...activeLabelStyles
            },
            label: (props) => ({
              ...activeStyles,
              backgroundColor: mode('#0E1633', '#0E1633')(props),
            })
          }
        },
      }
    }
  }
};
